import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AppBarWithButtons } from '../../../../designe/app-bars/app-bar-with-action-buttons/AppBarWithButtons';
import AppTextField from '../../../../designe/textfields/app-text-field/AppTextField';
import { useStyles } from './SaveSet.styles';

interface ISaveSetProps {
  onCancel: () => void;
  onSaveSet: (title: string) => Promise<any>;
}

export default function SaveSet(props: ISaveSetProps) {
  const { onCancel, onSaveSet } = props;
  const [loader, setLoader] = useState<boolean>(false);
  const [title, setTitle] = useState('');
  const { t } = useTranslation();
  const theme = useTheme();

  const { classes } = useStyles(theme);

  return (
    <Box className={classes.saveSetWrapper}>
      <Box display="flex" flexDirection="column" gap={1}>
        <AppTextField
          label={t('common.title')}
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </Box>

      <Box className={classes.saveSetBottom}>
        <AppBarWithButtons
          loading={loader}
          onClick={() => {
            setLoader(true);
            onSaveSet(title).finally(() => {
              setLoader(false);
            });
          }}
          onCancelClick={onCancel}
        />
      </Box>
    </Box>
  );
}
